import { FindParamsDefault } from './find-params-default';

export interface FindParamsAnomalies extends FindParamsDefault {
  ticket_id?: string;
  'source.donation_code'?: string;
}
